import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import { Button, MobileStepper, Slide } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import RootState from "../../../redux/states/root.state";

const SpaConnectedCard: React.FC = () => {
  const [activeStep, setActiveStep] = React.useState(2);
  const [middleDirection, setMiddleDirection] = React.useState<'left' | 'right'>('left');
  const {spasConnectedLastWeek,spasConnectedThisWeek, onlineMovedSpas} = useSelector((state: RootState) => state.dashboard);
  const containerRef = React.useRef<HTMLDivElement>(null);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => {
      prevActiveStep===0 ? setMiddleDirection('left') : setMiddleDirection('right');
      return prevActiveStep + 1
    });
  };

  const handleBack = () => {
    setActiveStep(
      (prevActiveStep) => {
        prevActiveStep===2 ? setMiddleDirection('right') : setMiddleDirection('left');
        return prevActiveStep - 1
      });
  };

  return (
    <div className="connected-card" id="connected" ref={containerRef}>
      <div className="connected-head">
        <span className="connected-icon"><WifiTetheringIcon /></span>
        <span className="connected-title">Spas Connected</span>
      </div>

      {/* Each step keeps its count and label together so they slide as one block. */}
      <div className="connected-body">
        <Slide direction="left" in={activeStep===2} container={containerRef.current}>
          <div className="connected-slide">
            <strong className="connected-value">{onlineMovedSpas?.spa_guids??0}</strong>
            <span className="connected-label">Online<em>&nbsp;&amp; Moved</em></span>
          </div>
        </Slide>

        <Slide direction={middleDirection} in={activeStep===1} container={containerRef.current}>
          <div className="connected-slide">
            <strong className="connected-value">{spasConnectedThisWeek?.spa_guids?.length??0}</strong>
            <span className="connected-label">Connected<em>&nbsp;This Week</em></span>
          </div>
        </Slide>

        <Slide direction="right" in={activeStep===0} container={containerRef.current}>
          <div className="connected-slide">
            <strong className="connected-value">{spasConnectedLastWeek?.spa_guids?.length??0}</strong>
            <span className="connected-label">Connected<em>&nbsp;Last Week</em></span>
          </div>
        </Slide>
      </div>

      <MobileStepper
        className="connected-stepper"
        variant="dots"
        steps={3}
        activeStep={activeStep}
        sx={{
          background: 'none',
          "& .MuiMobileStepper-dot": {
            background: "var(--icon-disabled)",
          },
          "& .MuiMobileStepper-dotActive": {
            background: "var(--color-sucess)",
          },
          "& .MuiButtonBase-root": {
            color: "var(--color-sucess)",
          },
        }}
        position="static"
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === 2}>
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            <KeyboardArrowLeft />
          </Button>
        }
      />
    </div>
);
};

export default SpaConnectedCard;
